import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { SkipToMainContent } from 'autogen/translation-keys/trans-website-shared-accessibility';
import { Button } from 'components/Button';
import useRequestContext from 'hooks/user/useRequestContext';

const StyledButton = styled(Button)`
    margin: ${({ theme }) => theme.Spacing16};
    position: absolute;
    top: 0;
    inset-inline-start: 0;
    z-index: 2000;
    transform: scale(0);

    &:focus {
        transform: scale(1);
    }

    @media print {
        display: none;
    }
`;

function SkipToLink() {
    const { isClubMatasApp, posRequest } = useRequestContext();
    const { isPosRequest } = posRequest || {};
    const { t } = useTranslation();

    if (isClubMatasApp || isPosRequest) {
        return null;
    }

    return (
        <StyledButton variant="primary" href={'#mainContent'} forwardedAs={'a'}>
            {t(SkipToMainContent)}
        </StyledButton>
    );
}

export default SkipToLink;
